"use strict";
/*
 * Created on 20.03.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PromotionSplitDTO_1 = require("../model/PromotionSplitDTO");

var PromotionSplitDTOConverter_1 = require("./PromotionSplitDTOConverter");
/**
 * @author ZSr
 * @author Radek Beran
 */


var PromotionSplitDTOConverterImpl =
/*#__PURE__*/
function (_PromotionSplitDTOCon) {
  _inherits(PromotionSplitDTOConverterImpl, _PromotionSplitDTOCon);

  function PromotionSplitDTOConverterImpl() {
    _classCallCheck(this, PromotionSplitDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionSplitDTOConverterImpl).apply(this, arguments));
  }

  _createClass(PromotionSplitDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PromotionSplitDTO_1.PromotionSplitDTO(PromotionSplitDTO_1.PromotionSplitDTO.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)), PromotionSplitDTO_1.PromotionSplitDTO.schema.yearNumber.valueOfField(source), PromotionSplitDTO_1.PromotionSplitDTO.schema.weekNumber.valueOfField(source), PromotionSplitDTO_1.PromotionSplitDTO.schema.split.valueOf(conversions.toBigNumber(source.split)), PromotionSplitDTO_1.PromotionSplitDTO.schema.splitVolume.valueOf(conversions.toBigNumber(source.splitVolume)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        yearNumber: source.yearNumber,
        weekNumber: source.weekNumber,
        split: conversions.fromBigNumber(source.split),
        splitVolume: conversions.fromBigNumber(source.splitVolume)
      });
      return result;
    }
  }]);

  return PromotionSplitDTOConverterImpl;
}(PromotionSplitDTOConverter_1.PromotionSplitDTOConverter);

exports.PromotionSplitDTOConverterImpl = PromotionSplitDTOConverterImpl;